export enum CacheInvalidationAction {
  // Core
  GET_PRODUCT_STOCK = "getProductStock",
  GET_PRODUCT = "getProduct",
  GET_PRODUCTS = "getProducts",
  GET_PRODUCT_BY_REFERENCE_AUTOCOMPLETE = "getProductByReferenceAutocomplete",
  GET_PRODUCT_BY_REFERENCE = "getProductByReference",
  GET_PRODUCT_BY_ID = "getProductById",
  GET_CATEGORY_PRODUCTS = "getCategoryProducts",
  GET_COMPANY_BY_ID = "getCompanyById",
  GET_COMPANIES = "getCompanies",
  GET_COORDINATORS = "getCoordinators",
  GET_USERS = "getUsers",
  GET_USER_BY_ID = "getUserById",
  GET_PROJECTS = "getProjects",
  GET_PROJECT_BY_ID = "getProjectById",
  GET_DOCKYARDS = "getDockyards",
  GET_DOCKYARD_BY_ID = "getDockyardById",
  GET_EDBS = "getEDBs",
  GET_EDB_BY_ID = "getEdbById",
  GET_INTEGRATED_ORDERS_BY_EDB_ID = "getIntegratedOrdersByEdbId",
  GET_OPS = "getOPs",
  GET_OP = "getOp",
  GET_OPS_WITH_PARCEL = "getOpsWithParcel",
  GET_OP_BY_ID = "getOpById",
  GET_OPS_BY_EDB = "GetOpsByEdb",
  GET_CATEGORIES_BY_COMPANY_ID = "getCategoriesByCompanyId",
  GET_CATEGORIES = "getCategories",
  GET_CATEGORY_BY_ID = "getCategoryById",
  GET_ENTREPOTS = "getEntrepots",
  GET_ENTREPOT_BY_ID = "getEntrepotById",
  GET_REFERENCEMENTS = "getReferencements",
  GET_REFERENCING_CATEGORY = "getReferencingCategory",
  GET_RECEPTIONS = "getReceptions",
  GET_RECEPTION_BY_ID = "getReceptionById",
  GET_RECEPTION = "getReception",
  IS_PRODUCT_IN_ORDER = "isProductInOrder",
  IS_PRODUCT_IN_A_RECEPTION = "isProductInAReception",
  CHECK_PRODUCT_EXIST_IN_EDB = "checkProductExistInEdb",
  GET_SECTORS = "getSectors",
  IS_RECEPTION_IN_EDB = "isReceptionInEdb",
  GET_WMS_CONFIG = "getWMSConfig",
  // Orders
  GET_ORDERS = "getOrders",
  GET_ORDER = "getOrder",
  GET_ORDER_BY_ID = "getOrderById",
  GET_ORDER_IN_EDB = "getOrderInEdb",
  // Shipping
  GET_SHIPMENTS_WITH_POPULATE_OPS = "getShipmentsWithPopulateOps",
  GET_SHIPPING_RECORDS = "getShippingRecords",
  GET_SHIPPING_RECORD = "getShippingRecord",
  GET_OPS_WITH_PARCEL_AND_NO_SHIPPING_RECORD = "getOpsWithParcelAndNoShippingRecord",
  GET_SHIPMENTS_WITH_OPS_AND_COMPANIES = "getShipmentsWithOpsAndCOmpanies",
  GET_SHIPMENTS = "getShipments",
}
